import { render, staticRenderFns } from "./MobileFriendlyRow.vue?vue&type=template&id=32eaa498&scoped=true&"
import script from "./MobileFriendlyRow.vue?vue&type=script&lang=ts&"
export * from "./MobileFriendlyRow.vue?vue&type=script&lang=ts&"
import style0 from "./MobileFriendlyRow.vue?vue&type=style&index=0&id=32eaa498&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eaa498",
  null
  
)

export default component.exports